module.exports = __webpack_public_path__ + "static/media/calender-bg.6c45116e.png";